<template>
	<swiper-container
		ref="slider"
		loop="true"
		grid-fill="row"
		space-between="20"
		pagination="true"
		@init="onInit($event)"
	>
		<slot></slot>
	</swiper-container>
</template>

<script lang="ts">
import { defineComponent, ref, PropType } from 'vue';
import { Swiper } from 'swiper';
import { SwiperOptions } from 'swiper/types';
import { register } from "swiper/element/bundle";

export default defineComponent({
	name: 'AppSlider',
	props: {
		options: Object as PropType<SwiperOptions>
	},
	data() {
		return {
			swiper: undefined as Swiper|undefined,
		}
	},
	methods: {
		onInit(event: CustomEvent) {
			this.swiper = event.detail[0];
			this.swiper!.params.breakpoints = {
				0: {
					slidesPerView: 1.4,
					grid: { rows: 1 }
				},
				400: {
					slidesPerView: 2,
				},
				900: {
					slidesPerView: 3,
					spaceBetween: 30,
					grid: { rows: 3 }
				}
			};
		},
	},
	created() {
		if (customElements.get('swiper-container') === undefined) {
			register();
		}
	},
	beforeDestroy() {
		this.swiper?.destroy();
		this.swiper = undefined;
	}
})

</script>

<style scoped>
* {
	--swiper-pagination-color: var(--primary-1);
	--swiper-pagination-bottom: -4px;
}
</style>
